"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Checkbox = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "SelectionListItem__Checkbox",
  componentId: "sc-17m4ly7-0"
})([""]);

Checkbox.defaultProps = {
  as: "input",
  type: "checkbox"
};

const SelectionListItem = ({ checked, onChange, children }) => _react2.default.createElement(
  _Box2.default,
  { className: "SelectionListItem", border: 1, p: 2 },
  _react2.default.createElement(
    _Text2.default,
    { as: "label", fontSize: 1, color: "palette.ink.normal" },
    _react2.default.createElement(Checkbox, { mr: 2, checked: checked, onChange: onChange }),
    children
  )
);

SelectionListItem.propTypes = {
  checked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.node
};

exports.default = SelectionListItem;